import type { ReactNode } from "react";
import { Grid, Typography } from "@mui/material";

interface DetailRowProps {
  label: string;
  value: ReactNode;
}

/**
 * 詳細行コンポーネント
 */
export const DetailRow = ({ label, value }: DetailRowProps): JSX.Element => {
  const displayValue =
    value === undefined || value === null || value === "" ? "-" : value;

  return (
    <Grid item xs={12}>
      <Grid container spacing={1} alignItems="flex-start">
        <Grid item xs={12} sm={4} md={3}>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: 700 }}
          >
            {label}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={9}>
          <Typography variant="body1">{displayValue}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
